import { BaseIcon } from '@favordelivery/tupperware/lib/components/icons/baseIcon'

export const PinFilled = props => (
  <BaseIcon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 10.8261C4 6.47826 7.59 3 12 3C16.41 3 20 6.47826 20 10.8261C20 14.0365 15.6382 19.1434 13.356 21.5956C12.6152 22.3917 11.3848 22.3917 10.644 21.5956C8.36183 19.1434 4 14.0365 4 10.8261ZM12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z"
      fill="var(--primaryColor)"
    />
  </BaseIcon>
)

export default PinFilled
